import React from 'react'

import { Card } from '@material-ui/core'

import HeaderWithFilterButton from '../CommonContent/IndividualHeader/IndividualHeader'
import HeaderWithActions from '../CommonContent/IndividualActionGroups/IndividualActionGroups'
import CardList from './CardContainer/CardContainer'
import Spinner from '../../../UI/Spinner/Spinner'

const individualContent = ({
  companyName,
  filtered,
  pageLoading,
  pagePermission,
  empRecords,
  selectedEmps,
  selectedResults,
  empCheckboxChanged,
  pagination,
  pageChanged,
  perPageChanged,
  copyButtonClicked,
  assignButtonClicked,
  assignButtonDisabled,
  filterButtonClicked,
  importButtonClicked,
  exportButtonClicked,
  exportButtonDisabled,
  deleteButtonClicked,
  bulkDeleteButtonClicked,
  bulkDeleteButtonDisabled,
  selectAllClicked,
  selectAllDisabled,
  actionClicked,
  actionDisabled
}) => {
  let content = <Spinner />
  if (!pageLoading) {
    content = (
      <CardList
        copyButtonClicked={copyButtonClicked}
        deleteButtonClicked={deleteButtonClicked}
        empRecords={empRecords}
        pagination={pagination}
        pageChanged={pageChanged}
        perPageChanged={perPageChanged}
        selectedEmps={selectedEmps}
        selectedResults={selectedResults}
        empCheckboxChanged={empCheckboxChanged}
        filtered={filtered}
        pagePermission={pagePermission}
      />
    )
  }

  return (
    <Card>
      <HeaderWithFilterButton
        pagePermission={pagePermission}
        filterButtonClicked={filterButtonClicked}
        exportButtonClicked={exportButtonClicked}
        exportButtonDisabled={exportButtonDisabled}
        importButtonClicked={importButtonClicked}
        pageTranslateKey={'individualAssignment'}
      />
      <HeaderWithActions
        companyName={companyName}
        selectAllClicked={selectAllClicked}
        selectAllDisabled={selectAllDisabled}
        assignButtonClicked={assignButtonClicked}
        assignDisabled={assignButtonDisabled || selectedEmps.length === 0 || !pagePermission.is_add}
        bulkDeleteButtonClicked={bulkDeleteButtonClicked}
        bulkDeleteDisabled={bulkDeleteButtonDisabled || !pagePermission.is_delete}
        actionClicked={actionClicked}
        actionDisabled={actionDisabled}
      />
      {content}
    </Card>
  )
}

export default individualContent
